// React
import { useState, useMemo } from 'react';

// App Component
import PreferredList from './PreferredList';
import ListAll from './ListAll';
import HistoryTable from './HistoryTable';
import CaptureExercise from './CaptureExercise';

// Amplify UI
import '@aws-amplify/ui-react/styles.css';
import {
    Button,
    Card,
    Flex,
    Heading,
    ToggleButtonGroup,
    ToggleButton,
    defaultDarkModeOverride,
    ThemeProvider,
} from '@aws-amplify/ui-react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import './App.css';
import 'react-tabs/style/react-tabs.css';

// Amplify
import { Amplify } from 'aws-amplify';
import { withAuthenticator } from '@aws-amplify/ui-react';
import awsExports from './aws-exports.js';
import ListForDate from './ListForDate';
Amplify.configure(awsExports);

const theme = {
    name: 'my-theme',
    overrides: [defaultDarkModeOverride],
};

function App({ user, signOut }) {
    const [colorMode, setColorMode] = useState('light');
    const [selectedExercise, setSelectedExercise] = useState([]);
    const [mustSave, setMustSave] = useState(false); 
    const [mustClose, setMustClose] = useState(false); 
    const [restartKey, setRestartKey] = useState("");
    const [currentExercise, setCurrentExercise] = useState(blankExercise());
    
    const userId = useMemo(
        () => user.attributes?.email || user.username,
        [user]
    );

    function handleHistoryFrameClose() {
        setMustClose(false)
        setSelectedExercise("");
        setRestartKey("");
    }

    function showHistoryFrame(exercise) {
        console.log('in showHistoryFrame:'+ exercise+ ":" + selectedExercise);
        if (exercise !== selectedExercise) {
            setMustSaveWrapper();
            setRestartKey("");
            setTimeout(() => {
                setSelectedExercise(exercise);
            }, 100);
        } else
            setSelectedExercise(exercise);

    }

    function setMustSaveWrapper() {
        setMustSave(!mustSave);
    }

    function blankExercise() {
        var ex = {
            "date": "", 
            "details": "", 
            "order" : 1,
            "sets": []
        };
        for (let i=0; i<3; i++) {
            var set = {
                "reps": 0, 
                "weight": 0, 
                "sore": false, 
                "cheat": false,
                "key": i,
            };
            ex.sets.push(set);
        }
        return ex;
    }

    
    return (
        <ThemeProvider theme={theme} colorMode={colorMode}>
            <Card height="100vh">
                <Flex
                    justifyContent="flex-end"
                    alignItems="right"
                    alignContent="flex-end"
                >
                    <Button
                        size="small"
                        onClick={() => signOut()}
                            style={{ marginLeft: '20px' }}
                    >
                        Sign Out
                    </Button>
                </Flex>
                <Flex
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="center"
                    alignContent="flex-start"
                    wrap="nowrap"
                    gap="10px"
                >
                    <Heading level={2}>
                        Record your daily workout
                    </Heading>
                    <Tabs class="amplify-tabs" defaultIndex={1}>
                        <TabList>
                            <Tab class="amplify-tabs-item" title="Preferred">Preferred</Tab>
                            <Tab class="amplify-tabs-item" title="By Date">By Date</Tab>
                            <Tab class="amplify-tabs-item" title="All">All</Tab>
                        </TabList>
                        <TabPanel value="Preferred">
                            <PreferredList
                                showHistoryFn={showHistoryFrame}
                            />
                        </TabPanel>
                        <TabPanel value="By Date">
                            <ListForDate
                                showHistoryFn={showHistoryFrame}
                            />
                        </TabPanel>
                        <TabPanel value="All">
                            <ListAll
                                showHistoryFn={showHistoryFrame}
                            />
                        </TabPanel>
                    </Tabs>
                    
                    <ToggleButtonGroup
                        value={colorMode}
                        isExclusive
                        onChange={(value) => setColorMode(value)}
                    >
                        <ToggleButton value="light">Light</ToggleButton>
                        <ToggleButton value="dark">Dark</ToggleButton>
                        <ToggleButton value="system">System</ToggleButton>
                    </ToggleButtonGroup>
                    
                    <HistoryTable
                        selectedExercise={selectedExercise}
                        closeFn={handleHistoryFrameClose}
                        setMustSave={setMustSaveWrapper}
                        setMustClose={setMustClose}
                        setCurrentExercise={setCurrentExercise}
                        restartKey={restartKey}
                        setRestartKey={setRestartKey}
                    />
                    <br />
                    <br />
                    <br />
                    <CaptureExercise
                        selectedExercise={selectedExercise}
                        setSelectedExercise={setSelectedExercise}
                        closeFn={handleHistoryFrameClose}
                        mustSave={mustSave}
                        setMustSave={setMustSaveWrapper}
                        mustClose={mustClose}
                        setMustClose={setMustClose}
                        currentExercise={currentExercise}
                        setCurrentExercise={setCurrentExercise} 
                        blankExercise={blankExercise}
                    />
                    <br />
                </Flex>
            </Card>
        </ThemeProvider>
    );
}

export default withAuthenticator(App);
